module.exports = __webpack_public_path__ + "static/media/logo-aghux-hubrasil-negativo.1233ad67.svg";